import { render, staticRenderFns } from "./p-scheduler.vue?vue&type=template&id=f15d3d34"
import script from "./p-scheduler.vue?vue&type=script&lang=ts"
export * from "./p-scheduler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports